"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import ScrollFloat from "@/components/ui/react-bits/ScrollFloat";
import { getMarketplaceUrl } from "@/lib/marketplace-utils";
import { useRouter } from "next/navigation";

const DiscoverSection: React.FC = () => {
  const router = useRouter();

  const handleSignUp = () => {
    router.push(getMarketplaceUrl('/register/worker/sign-up'));
  };

  return (
    <div className='font-yellix mt-0 flex flex-col items-center justify-center text-center md:min-h-[65vh] md:px-4 md:py-0'>
      <div className='pt-6 pb-10'>
        <ScrollFloat
          animationDuration={1}
          ease='back.inOut(2)'
          scrollStart='center bottom+=50%'
          scrollEnd='bottom bottom-=40%'
          stagger={0.03}
          containerClassName='border-b-[0.8px] border-border-primmary py-10'
          textClassName='text-[100px]! md:text-[200px]! xl:text-[300px]! font-medium! leading-[100%]! text-text-title/90! [&_.char:last-child]:text-link-primary'
        >
          Onyx.
        </ScrollFloat>
      </div>
      <h2 className='text-text-title mb-1 text-base font-medium md:mb-4 md:max-w-sm md:text-[26px] md:font-normal'>
        Discover new possibilities, get inspired by stability
      </h2>
      <p className='text-text-title mb-5 text-sm font-medium md:mb-8 md:max-w-xl md:font-normal lg:text-base'>
        and be the first to know about new products and credit options.
      </p>

      {/* Form Input and Button */}
      <div className='flex w-full flex-col items-center justify-center gap-3 md:flex-row md:gap-3'>
        <Input
          type='email'
          placeholder='johndoe@email.com'
          className='text-text-title bg-primary-input-bg placeholder:text-text-disabled w-2/3 rounded-full border-none px-3 text-xs font-semibold focus:ring-0 focus:outline-none focus-visible:ring-0 md:w-100 md:px-9 md:text-base lg:text-sm'
        />

        <Button onClick={handleSignUp} className='w-2/3 rounded-full px-6 text-xs font-semibold duration-300 ease-in-out hover:scale-95 md:w-auto md:px-8 lg:h-[45px] lg:text-base'>
          Sign up
        </Button>
      </div>
    </div>
  );
};

export default DiscoverSection;
